<template>
    <div>
        <div class="checkout-review-basket-page-container">
            <section class="text-center bg-white main-heading-page">
                <h2>{{ $resourceString["checkout.Title.ReviewBasket"] }}</h2>
            </section>
            <div class="container-fluid">
                <div class="row align-items-start">
                    <div class="col-12 col-lg-8 col-xl-9">
                        <div class="checkout-review-basket-page-wrap">

                            <!-- shipping -->
                            <div class="checkout-review-basket-page-details-row checkout-review-details-shipping">
                                <div class="row">
                                    <div class="col-md-12">
                                        <h5 class="primary-heading font-weight-bold">
                                            {{ $resourceString['checkout.ReviewBasket.Title.Shipping'] }}                                           
                                            <button @click="shippingEditHandler" class="edit-btn" type="button">{{ $resourceString['common.Label.Edit'] }}</button>
                                        </h5>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-5 col-sm-6 col-12">
                                        <div class="checkout-review-details-col">
                                            <div class="details-label-heading">
                                                <p>{{ $resourceString["checkout.Shipping.Label.ShipTo"] }}:</p>
                                            </div>
                                            <div class="details-body">
                                                <div class="details-body-shipping-address"  v-if="getCurrentAddressIndex">
                                                    <span>{{ currentAddress.firstName }} {{ currentAddress.lastName }}</span>
                                                    <span>
                                                        {{
                                                            currentAddress.streetLine2
                                                            ? currentAddress.streetLine1 + ", Suite" + currentAddress.streetLine2
                                                            : currentAddress.streetLine1
                                                        }}.
                                                    </span>
                                                    <span>{{ currentAddress.city }}, {{ currentAddress.state }}, {{ currentAddress.postalCode }}, {{ currentAddress.country }}.</span>                                                  
                                                </div>
                                                <div class="details-body-shipping-address" v-else>
                                                    <span>N/A</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-7 col-sm-6 col-12">
                                        <div class="checkout-review-details-col checkout-review-shipping-option-details">
                                            <div class="details-label-heading">
                                                <p>{{ $resourceString["checkout.Shipping.Label.ShippingOptions"] }}:</p>
                                            </div>
                                            <div class="details-body">
                                                <div class="checkout-review-shipping-options-list" v-if="checkoutData.ShippingOption">
                                                    <span>{{ getShippingOptionName(checkoutData.ShippingOption).title || 'N/A' }}</span>
                                                     <span>{{ getShippingOptionName(checkoutData.ShippingOption).description || 'N/A'}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                             <!-- Project Information -->
                             <div class="checkout-review-basket-page-details-row checkout-review-details-shipping">
                                <div class="row">
                                    <div class="col-md-12">
                                        <h5 class="primary-heading font-weight-bold">
                                            {{ $resourceString['checkout.ProjectInformation.Title.MainHeading'] }} 
                                            <button @click="projectInfoEditHandler" class="edit-btn" type="button">{{ $resourceString['common.Label.Edit'] }}</button>
                                        </h5>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="checkout-review-details-col">
                                            <div class="details-label-heading">
                                                <p>{{ $resourceString["checkout.ProjectInformation.Label.ProjectName"] }}:</p>
                                            </div>
                                            <div class="details-body">
                                                <div class="details-body-shipping-address">
                                                    <span>{{ this.checkoutData.ProjectName || 'N/A'}}</span>                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </div>                                  
                                </div>
                            </div>

                             <!-- Product sample list -->
                             <div class="checkout-review-basket-page-details-row checkout-review-details-shipping">
                                <div v-for="list in Object.keys(checkoutItemList)" :key="list" v-if="checkoutItemList[list].length > 0">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <h5 class="primary-heading font-weight-bold">                                          
                                                 <span v-if="list.toLowerCase() === 'siteitems'">{{ $resourceString['myBasket.Label.IndividualSamples'] }} : {{ checkoutItemCount.siteItems }}</span>
                                                 <span v-if="list.toLowerCase() === 'projectitems'">{{ $resourceString['myBasket.Label.ProjectSamples'] }} : {{ checkoutItemCount.projectItems }}</span>
                                                 <span v-if="list.toLowerCase() === 'trayitems'">{{ $resourceString['myBasket.Label.DesignTraySample'] }} : {{ checkoutItemCount.trayItems }}</span>
                                                <button @click="productSampleEditHandler(list)" class="edit-btn" type="button">{{ $resourceString['common.Label.Edit'] }}</button>
                                            </h5>
                                        </div>
                                    </div> 
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="checkout-review-details-col">
                                                <basket-item 
                                                :listItems="checkoutItemList[list]" 
                                                :listName="list.toLowerCase() === siteItems.toLowerCase() 
                                                            ? siteItems : list.toLowerCase() === projectItems.toLowerCase()
                                                            ? projectItems : list.toLowerCase() === trayItems.toLowerCase() 
                                                            ? trayItems : ''"
                                                :isCheckoutPage="true"
                                                :isClearAll="false"
                                                />                                               
                                            </div>
                                        </div>                                  
                                    </div>                                  
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="col-12 col-lg-4 col-xl-3 sidebar-position-sticky sidebar-mobile-device">
                        <div class="checkout-basket-sidebar-warpper">
                            <div class="checkout-basket-sidebar-container">
                                <pc-basket-sidebar
                                    :individualSamples="checkoutItemList.siteItems.length > 0"
                                    :individualSamplesCount="checkoutItemCount.siteItems"
                                    :projectSamples="checkoutItemList.projectItems.length > 0"
                                    :projectSamplesCount="checkoutItemCount.projectItems"
                                    :designTraySample="checkoutItemList.trayItems.length > 0"
                                    :designTraySampleCount="checkoutItemCount.trayItems"
                                    :backLabel="$resourceString['checkout.Button.BackToProject']"
                                    :backAction="backHandler"
                                    :nextLabel="$resourceString['checkout.Button.SubmitSampleOrder']"
                                    :nextAction="continueToCheckoutHandler"
                                    :isNextDisabled="OrderSampleEnabled"   
                                    :isError="isErrorForSideBar()"
                                    :errorMsg="errorMsgForSideBar()"      
                                /> 
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import pcBasketSidebar from "../new-basket-page/pc-basket-sidebar.vue";
import BasketItem from "../new-basket-page/pc-basket-list.vue";
import { CHECKOUT_PROJECT_INFORMATION, CHECKOUT_SHIPPING, BASKET_SITEITEMS, BASKET_PROJECTITEMS, BASKET_TRAYITEMS } from "../../../constants/checkout-constant";
export default {
    props: {
        listItemTitle: {
            type: Function
        },    
        createStudio: {
            type: Object,
            required: false
        }
    },
    data() {
        return {
            siteItems: BASKET_SITEITEMS,
            projectItems: BASKET_PROJECTITEMS,
            trayItems: BASKET_TRAYITEMS
        }
    },
    components: {
        pcBasketSidebar,
        BasketItem
    },
    computed: {
        ...mapGetters({
            checkoutData: "newCheckoutPage/checkoutData",
            checkoutItemCount: "newCheckoutPage/getCheckoutItemCount",
            checkoutItemList: "newCheckoutPage/checkoutItemList",
            getCurrentAddressIndex: "newCheckoutPage/getCurrentAddressIndex",
            getAddressById: "newCheckoutPage/getAddressById",
            OrderSampleEnabled: "productDetail/getisOrderSampleEnabled",
            showroomCodeName: "newCheckoutPage/showroomCodeName",
            vehicleMake: "newCheckoutPage/vehicleMake",
            vehicleModel: "newCheckoutPage/vehicleModel",
            vehicleColor: "newCheckoutPage/vehicleColor",
            deliveryMethod: "newCheckoutPage/deliveryMethod",
        }),
        currentAddress() {
            if(this.getCurrentAddressIndex) {
                return this.getAddressById(this.getCurrentAddressIndex) || {}
            }
            return {}
        }
    },
    created() {
        this.isOrderSampleEnabled();
    },
    methods: {
        ...mapActions({
            updateCheckoutStep: "newCheckoutPage/updateCheckoutStep",
            isOrderSampleEnabled: "productDetail/isOrderSampleEnabled",
            setVehicleMake: "newCheckoutPage/setVehicleMake",
            setVehicleModel: "newCheckoutPage/setVehicleModel",
            setVehicleColor: "newCheckoutPage/setVehicleColor",
            setShowroomCodeName: "newCheckoutPage/setShowroomCodeName",
            setDeliveryMethod: "newCheckoutPage/setDeliveryMethod",
            checkoutSubmit: "newCheckoutPage/checkoutSubmit",
        }),
        shippingEditHandler() {
            this.updateCheckoutStep(CHECKOUT_SHIPPING);            
        },
        projectInfoEditHandler() {
            this.updateCheckoutStep(CHECKOUT_PROJECT_INFORMATION);
        },
        productSampleEditHandler() {
            let url = new URL(window.location);
            window.location.href = url.origin + "/Basket";
        },
        getShippingOptionName(value) {
            const shippingOptionName = {
                standard: {
                    title: this.$resourceString["checkout.Shipping.Standard"],
                    description: this.$resourceString["checkout.Shipping.Standard.Description"]
                },
                secondday: {
                    title: this.$resourceString["checkout.Shipping.SecondDay"],
                    description: this.$resourceString["checkout.Shipping.SecondDay.Description"]
                },
                ground: {
                    title: this.$resourceString["checkout.Shipping.Ground"],
                    description: this.$resourceString["checkout.Shipping.Ground.Description"]
                },
                sameday: {
                    title: this.$resourceString["checkout.Shipping.SameDay"],
                    description: this.$resourceString["checkout.Shipping.SameDay.Description"]
                },
                localpickup: {
                    title: this.$resourceString["checkout.Shipping.LocalPickup"],
                    description: this.$resourceString["checkout.Shipping.LocalPickup.Description"]
                },
            }
            if(value) {
                return shippingOptionName[value.toLowerCase()] || {}
            } 
            return {}
        },
        backHandler() {
            this.updateCheckoutStep(CHECKOUT_PROJECT_INFORMATION);
        },
        continueToCheckoutHandler() {
            this.setVehicleMake(this.createStudio.vehicleMake);
            this.setVehicleModel(this.createStudio.vehicleModel);
            this.setVehicleColor(this.createStudio.vehicleColor);
            this.setShowroomCodeName(this.createStudio.warehouseCode);
            this.setDeliveryMethod(this.createStudio.deliveryMethod);
            this.checkoutSubmit();
        },
        errorMsgForSideBar() {
            return (
                this.checkoutData.ValidationErrors 
                ?  this.checkoutData.ValidationErrors
                : this.checkoutData.ValidationWarnings 
                ? this.checkoutData.ValidationWarnings 
                : '' 
            )
        },
        isErrorForSideBar() {
            return (this.checkoutData.ValidationErrors || this.checkoutData.ValidationWarnings )
        },
    },
}
</script>